import axios from 'axios';

async function getPass(pass_code) {
    const passResponse = await axios.get(`pass/get?pass_code=${pass_code}`, { withCredentials: false });
    return passResponse?.data;
}

async function updatePass(pass_code, formData) {
    const passResponse = await axios.post(`pass/update/${pass_code}`, formData, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
    });
    return passResponse?.data;
}

export default {
    getPass,
    updatePass,
}
